export default "__VITE_ASSET__CAVviwIF__"